import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useApiClient } from "../../context/ApiClientContext";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";

const DetailsMissionForm = ({ mission }) => {
  const labelWidth = 150;
  const theme = useTheme();
  const [errors, setErrors] = useState({});
  const location = useLocation();
  const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString) return "";
    return dayjs(dateString).format("DD/MM/YYYY");
  };

  const [inputForm, setInputForm] = useState({
    title: "",
    description: "",
    valueTag: "",
    missionLevel: "",
    missionScheduleType: "",
    startDate: "",
    endDate: "",
    point: "",
    isContinueOnHoliday: "",
    isApproval: "",
    isPenalty: "",
    penaltyPoint: "",
    status: "",
    // date: "",
    createdName: "",
    createdDate: "",
  });
  // console.log('mission', mission);
  useEffect(() => {
    if (mission) {
      setInputForm((prev) => ({
        ...prev,
        ...mission,
        startDate: formatDateToDDMMYYYY(mission.startDate),
        endDate: formatDateToDDMMYYYY(mission.endDate),
        createdDate: formatDateToDDMMYYYY(mission.createdDate),
      }));
    }
  }, [mission]);

  const handleInputChange = (property, event) => {
    // console.log("value", event.target.value);

    const value = event.target.value;
    setInputForm((prevState) => ({
      ...prevState,
      [property]: value,
    }));
  };

  const renderField = (
    label,
    id,
    type = "text",
    select = false,
    rows,
    options = [],
    isCheckbox = false
  ) => (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: 1,
        mb: 2,
        alignItems: isCheckbox ? "center" : "flex-start",
      }}
    >
      <Typography
        sx={{
          minWidth: { sm: labelWidth },
          alignSelf: { sm: "center" },
        }}
      >
        {label}
      </Typography>

      {isCheckbox ? (
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(inputForm[id])}
                disabled={true}
                sx={{
                  "&.Mui-checked": { color: "#959968ff" },
                }}
              />
            }
            label=""
            sx={{ margin: 0 }}
          />
        </FormGroup>
      ) : (
        <TextField
          id={id}
          type={type}
          select={select}
          slotProps={{
            input: { readOnly: true }
          }}
          error={!!errors[id]}
          helperText={errors[id]}
          onChange={(e) => handleInputChange(id, e)}
          value={inputForm[id]}
          required
          fullWidth
          size="small"
          variant="outlined"
          multiline
          maxRows={rows}
        >
          {select &&
            options.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
        </TextField>
      )}
    </Box>
  );

  return (
    <Box sx={{ width: "100%" }}>


      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 6 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          {renderField("Mission Title", "title")}
          {renderField("Description", "description", "text", false, "4")}
          {renderField("Value Tag", "valueTag")}
          {renderField("Difficulty", "missionLevel", "select", true, 1, [
            { value: "Basic", label: "Basic" },
            { value: "Simple", label: "Simple" },
            { value: "Heavy", label: "Heavy" },
            { value: "Extreme", label: "Extreme" },
          ])}
          {renderField("Start Date", "startDate", "text")}
          {renderField("End Date", "endDate", "text")}
          {renderField("Approval", "isApproval", "checkbox", false, 1, [], true)}
          {renderField("Penalty", "isPenalty", "checkbox", false, 1, [], true)}
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          {renderField("Penalty Point", "penaltyPoint")}
          {renderField("Schedule", "missionScheduleType", "select", true, 1, [
            { value: "One Off", label: "One Off" },
            { value: "Daily", label: "Daily" },
            { value: "Weekly", label: "Weekly" },
            { value: "Monthly", label: "Monthly" },
          ])}
          {renderField("Mission Point", "point")}
          {renderField("Status", "status", "select", true, 1, [
            { value: "Active", label: "Active" },
            { value: "InProgress", label: "In Progress" },
            { value: "Completed", label: "Completed" },
            { value: "Upcoming", label: "Upcoming" },
          ])}
          {renderField("Created Date", "createdDate", "text")}
          {/* {renderField("Last Created Date", "updatedDate", "date")} */}
          {renderField("Created By", "createdName")}
          {renderField(
            "Continue on Holiday",
            "isContinueOnHoliday",
            "checkbox",
            false,
            1,
            [],
            true
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default DetailsMissionForm;
